import { HYDRATE } from 'next-redux-wrapper';

import { ResponseDto } from '@r1-frontend/api-domru/api-profile/v1/catch-up/get-state-catch-up';

import { THydrateAction } from '~/src/store';

export enum ECatchUpActionTypes {
    SET_CATCHUP_STATUS_STATE = 'SET_CATCHUP_STATUS_STATE',
}

export interface ICatchUpState {
    info: ResponseDto,
}

const initialState: ICatchUpState = {
    info: {
        0: null,
        state: [],
    },
};

export type TActions = {
    type: ECatchUpActionTypes,
    payload: ResponseDto,
};

export default function catchUpReducer(state = initialState, action: THydrateAction | TActions): ICatchUpState {
    switch (action.type) {
        case HYDRATE:
            return { ...state, ...action.payload.catchup };
        case ECatchUpActionTypes.SET_CATCHUP_STATUS_STATE:
            return {
                ...state,
                info: action.payload,
            };
        default:
            return state;
    }
}
